export default __webpack_public_path__ + "static/media/uts.9aea606d.ttf";